import { Component } from '@angular/core';
import { OfflineDebatesService } from '../offline-debates.service';
import * as fileSaver from 'file-saver';
import { LanguageService } from '../../../core/language/language.service';
import { OfflineDebateSessionDetail } from '../../../core/models/debates/offline-debates/offline-debate-session-detail';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-offline-debate-session-detail',
    templateUrl: './offline-debate-session-detail.component.html',
    styleUrls: ['./offline-debate-session-detail.component.css']
})
export class OfflineDebateSessionDetailComponent {
    session: OfflineDebateSessionDetail;
    private languageID: number;
    public pathname: string;

    constructor(private _offlineDebatesService: OfflineDebatesService,
        private _languageService: LanguageService,
        private _route: ActivatedRoute) {
        this.languageID = this._languageService.selectedLanguageId;
    }

    ngOnInit() {
        this.pathname = '/public-offline-debates/public-offline-debate-session-detail';
        const id = +this._route.snapshot.params['id'];
        this.session = new OfflineDebateSessionDetail();
        this.session.files = [];
        this.session.questionAnswers = [];
        this._offlineDebatesService.getOfflineDebateSessionDetail(id, this.languageID).subscribe(result => {
            this.session = result;
        });
    }

    downloadOfflineDebateSessionFile(fileId: number, fileName: string) {
        this._offlineDebatesService.downloadOfflineDebateSessionFile(fileId, this.languageID).subscribe(blob => {
            fileSaver.saveAs(blob, fileName);
        });
    }
}
